import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogProps } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React, { ReactNode, useContext } from 'react';
import LocalizationContext from '../../contexts/LocalizationContext';
import { useGlobalStyles } from '../../Home';
import GlobalContext from 'src/contexts/GlobalContext';


export interface ConfirmPopupProps extends DialogProps {
    open: boolean;
    title: string;
    content?: ReactNode;
    confirmText?: string;
    confirmDanger?: boolean;
    cancelText?: string;
    onClose?: () => void;
    onConfirm: () => void;
    allowCancel?: boolean;
    loadingSpiner?: boolean;
}

const ConfirmPopup = ({
    open,
    title,
    content = undefined,
    confirmText = undefined,
    confirmDanger = false,
    cancelText = undefined,
    onClose,
    onConfirm,
    allowCancel = true,
    ...otherProps
}: ConfirmPopupProps) => {
    const theme = useTheme();
    const classes = useGlobalStyles();
    const localization = useContext(LocalizationContext);
    const onClick = () => onConfirm();

    const isProcessing = React.useRef(false);
    const onClick2 = () => {
        if (isProcessing.current) return;

        isProcessing.current = true;
        onClick();

        setTimeout(() => {
            isProcessing.current = false;
        }, 400);
    };
    
    const global = useContext(GlobalContext);

    return (
        <Dialog
            {...otherProps}
            open={open}
            onClose={onClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            BackdropProps={{ style: { backgroundColor: '#00295244' } }}>
            <div id='popup-title' className={classes.dialogTitle}>
                {title}
            </div>
            <DialogContent>
                <div style={{ marginBottom: '12px', fontFamily: theme.typography.fontFamily, opacity: '0.9' }}>{content}</div>
            </DialogContent>
            <DialogActions style={{ padding: '8px 24px' }}>
                {global.loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        {allowCancel && (
                            <Button id='cancel-popup' onClick={onClose} color='primary' className={classes.defaultButton}>
                                {cancelText || localization.strings.cancel}
                            </Button>
                        )}
                        <Button
                            id='confirm-popup'
                            onClick={onClick2}
                            style={confirmDanger ? { color: theme.palette.error.main } : {}}
                            color='primary'
                            autoFocus
                            className={classes.defaultButton}>
                            {confirmText || localization.strings.confirm}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmPopup;
